var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, select, takeEvery } from 'redux-saga/effects';
import * as Actions from '../../results/resultsSlice';
import * as TrackingActions from '../trackingSlice';
import { getProcessDataById } from '../../processes/selectors';
function isAppointmentBooking(endpoint, formData, processData) {
    var _a, _b;
    if (!endpoint && !processData)
        return false;
    if ((processData === null || processData === void 0 ? void 0 : processData.ServiceRequest) || ((_a = processData === null || processData === void 0 ? void 0 : processData.Customer) === null || _a === void 0 ? void 0 : _a.ServiceRequest))
        return true;
    if (typeof (endpoint) === "string" && ((endpoint === null || endpoint === void 0 ? void 0 : endpoint.startsWith('serviceRequests')) || (endpoint === null || endpoint === void 0 ? void 0 : endpoint.startsWith('timekits')))) {
        if ((formData === null || formData === void 0 ? void 0 : formData.ServiceRequest) || ((_b = formData === null || formData === void 0 ? void 0 : formData.Customer) === null || _b === void 0 ? void 0 : _b.ServiceRequest)) {
            return true;
        }
    }
    return false;
}
export function sendBookingTrackEvent(action) {
    var _a, endpoint, formData, processId, processData, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, endpoint = _a.endpoint, formData = _a.formData, processId = _a.processId;
                if (!processId) return [3 /*break*/, 2];
                return [4 /*yield*/, select(function (state) { return getProcessDataById(state, processId); })];
            case 1:
                _b = _c.sent();
                return [3 /*break*/, 3];
            case 2:
                _b = null;
                _c.label = 3;
            case 3:
                processData = _b;
                if (!isAppointmentBooking(endpoint, formData, processData)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(TrackingActions.event({
                        category: 'Appointment',
                        action: 'created', label: processId !== null && processId !== void 0 ? processId : formData === null || formData === void 0 ? void 0 : formData.componentKey,
                    }))];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function actionWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery([Actions.sendFormToUrl.type, Actions.sendForm.type, Actions.sendAnswers.type], sendBookingTrackEvent)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
